<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'order-changeorder',
  components: {
    PageTable,
  },
}
</script>